/** Canonical source identity for section JSON across browser, Worker, and Node. */
export const SECTION_SOURCE_HASH_RE = /^[0-9a-f]{64}$/;

export function sectionSourceText(section) {
  return JSON.stringify([section?.html || '', section?.css || '', section?.js || '']);
}

export async function sectionSourceHash(section) {
  const digest = await crypto.subtle.digest(
    'SHA-256',
    new TextEncoder().encode(sectionSourceText(section))
  );
  return [...new Uint8Array(digest)].map((byte) => byte.toString(16).padStart(2, '0')).join('');
}
